import { CoinType } from '@starsoft/common/models';
import TransactionsModalsWithdrawContentFormCryptoContent from './Crypto';
import { useWithdrawSearchParams } from '@starsoft/common/hooks';
import { WithdrawMethodId } from '@starsoft/common/enums';

/**
 * TransactionsModalsWithdrawFormContent Component
 * This component determines the content to render based on the type of coin and withdrawal method.
 * It uses the `useWithdrawSearchParams` hook to retrieve the current coin type and withdrawal method ID.
 *
 * @returns {JSX.Element | null} The rendered component or null if no applicable content is found.
 *
 * @example
 * // Usage example:
 * <TransactionsModalsWithdrawFormContent />
 */
export default function TransactionsModalsWithdrawFormContent() {
  // Retrieve the current coin type and withdrawal method ID from search parameters
  const { coinType, withdrawMethodId } = useWithdrawSearchParams();

  // Determine the content to render based on the coin type
  switch (coinType) {
    case CoinType.Fiat:
      // For fiat coin types, check the withdrawal method ID
      switch (withdrawMethodId) {
        // If the withdrawal method matches any of the specified IDs, return null
        case WithdrawMethodId.BetterbroBrazillianPix?.toString():
        case WithdrawMethodId.PixtopayBrazillianPix?.toString():
        case WithdrawMethodId.BetterbroArgentineBankTransfer?.toString():
        case WithdrawMethodId.BetterbroIndianImps?.toString():
        case WithdrawMethodId.BetterbroMexicanSpei?.toString():
          return null;
      }
      break;
    case CoinType.Crypto:
      // For crypto coin types, render the crypto content component
      return <TransactionsModalsWithdrawContentFormCryptoContent />;
  }
}
